import axios from "axios";

const BASE_URL = "https://data.nadzor.app/api/admin_panel/gallery";

export const uploadImage = async (formData) => {
  const response = await axios.post(`${BASE_URL}/uploadImage.php`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const fetchImages = async (userId) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/img_test.php`,
      { user_id: userId },
      { headers: { "Content-Type": "application/json" } } // Ensure proper header
    );
    return response.data.images;
  } catch (error) {
    console.error(
      "Error fetching images:",
      error.response?.data || error.message
    );
    throw error; // Let the calling function handle it
  }
};

export const deleteImage = async (imageId) => {
  try {
    const response = await axios.post(`${BASE_URL}/delete.php`, {
      image_id: imageId,
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting image:", error);
    throw error;
  }
};

export const updateImageAlbum = async (imageId, albumId) => {
  try {
    const response = await axios.post(`${BASE_URL}/changeAlbum.php`, {
      image_id: imageId,
      album_id: albumId,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating image album:", error);
    throw error;
  }
};

export const updateImageCompression = async (
  imageId,
  compressionLevel,
  apiKey,
  userId
) => {
  const url = `${BASE_URL}/compressImage.php`; // Replace with the actual URL
  const payload = {
    image_id: imageId,
    compression_level: compressionLevel,
  };

  try {
    const response = await axios.post(url, payload);
    return response.data;
  } catch (error) {
    console.error("Failed to update compression:", error);
    throw error;
  }
};

export const updateImageDetails = async (imageId, title, description) => {
  try {
    const response = await axios.post(`${BASE_URL}/updateImageDetails.php`, {
      image_id: imageId,
      title: title || null,
      description: description || null,
    });
    return response.data;
  } catch (error) {
    console.error("Failed to update image details:", error);
    throw error;
  }
};
